unit uPreview;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls, WEBLib.Controls;

type
  TPreview = class(TForm)
  protected procedure LoadDFMValues; override; end;

var
  Preview: TPreview;

implementation

{$R *.dfm}

procedure TPreview.LoadDFMValues;
begin
  inherited LoadDFMValues;


  try
    Name := 'Preview';
    Width := 640;
    Height := 480;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
  finally
  end;
end;

end.
